import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


import { PaginationService } from 'Utilities/pagination.service';
import { GenerateService } from 'Utilities/generate.service';
import { Tag } from '../tag.model';
import { TagService } from '../tag.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-tag-list-table',
  template: require('./tag-list-table.component.html'),
})

/** Component class to display list of tags **/
export class TagListTableComponent implements OnInit {
  total = 0;
  pagesLeft = 0;
  infiniteScrollDisabled = false;
  tagList: Tag[];
  tagsToDelete: Tag[];
  isLoading = false;

  constructor(
    private tagService: TagService,
    private notificationService: ToastrService,
    private paginationService: PaginationService,
    private generateService: GenerateService,
  ) {
  }

  ngOnInit() {
    this.getTags();
  }

  /**
   * @desc Function to get tags
   * @return {void}
   */
  getTags(): void {
    this.isLoading = true;
    this.tagService
      .getTags()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe(res => {
        const tags = res.tags,
          len = tags.length;

        this.tagList = [];
        this.addTagsToList(tags, len);

        this.total = res.total;
        this.pagesLeft = this.paginationService.getNumberOfPagesLeft(this.tagList, this.total);
        this.infiniteScrollDisabled = this.pagesLeft <= 0;
      });
  }

  /**
   * @desc Function to add tags to the list
   * @param {array} tags - Array of tags to be added
   * @param {number} len - Number of tags
   * @return {void}
   */
  addTagsToList(tags: Array<Tag>, len?: number): void {
    let tag;
    const numberOfTags = len || tags.length;

    for (let i = 0; i < numberOfTags; i++) {
      tag = tags[i];
      this.tagList.push(tag);
    }
  }

  /**
   * Function to delete single tag
   * @param {object} tag - The tag to be deleted
   * @return {void}
   */
  deleteTag(tag: Tag, index: number): void {
    // Check if tag can be deleted
    if (!(tag && tag.id) || !index) {
      this.notificationService.error('Cannot remove tag');
      return;
    }

    // Delete tag
    this.tagService.deleteTags(tag.id).subscribe(res => {
      this.notificationService.success('Tag was successfully removed');
      this.tagList.splice(index, 1);
    });
  }

  /**
   * @desc Function to get more tags calculated by offset for infinite scroll
   * @return {void}
   */
  getTagsByOffset(): void {
    let params;
    if (this.pagesLeft > 0) {
      this.isLoading = true;

      this.pagesLeft--;

      params = this.generateService.generateSearchUrl({ offset: this.tagList.length });
      this.tagService
        .getTags(params).pipe(
        finalize(() => {
          this.isLoading = false;
        }),
      )
        .subscribe(res => {
          this.addTagsToList(res.tags);
        });
    } else {
      this.infiniteScrollDisabled = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tags/partials/tag-list-table.component.ts